import React from 'react';
import Radio from '@mos-cat/radio';
import { Heading } from '@mos-cat/typography';
import { t, Trans } from '@lingui/macro';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import { isApplicantMarried } from '../../../selectors/applicant';
import { CHILD_FIELD_NAME } from '../../../constants/fieldNames';
import { BORN_IN } from '../../../constants/child';
import { i18n } from '../../../helpers/i18n';

function ChildBornInCurrentMarriage({
  isVisible,
  bornInCurrentMarriage,
  onChange,
}) {
  if (!isVisible) return null;
  const { value, error, disabled } = bornInCurrentMarriage;
  return (
    <div className="ChildBornInCurrentMarriage StepContentBlock">
      <Heading level={3} className="PguFormGrid__row">
        <Trans>Ребёнок рожден в текущем браке?</Trans>
      </Heading>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={i18n._(t`Да`)}
          name={CHILD_FIELD_NAME.bornInCurrentMarriage}
          value={BORN_IN.currentMarriage}
          checked={value === BORN_IN.currentMarriage}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={i18n._(t`Нет`)}
          name={CHILD_FIELD_NAME.bornInCurrentMarriage}
          value={BORN_IN.notCurrentMarriage}
          checked={value === BORN_IN.notCurrentMarriage}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<any, any>({
  isVisible: isApplicantMarried,
  bornInCurrentMarriage: (state) => state.child.bornInCurrentMarriage,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange({ target: { name, value } }) {
    dispatch({
      type: 'child/bornInNotCurrentMarriage/reset',
      payload: { [name]: { value } },
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChildBornInCurrentMarriage);
